import {Component, ElementRef, Input, OnInit, ViewChild} from "@angular/core";
import {User} from "src/app/user-admin-module/models";
import {AuthService} from "src/app/auth-module/services";
import {Router} from "@angular/router";
import {USER_ROLES} from "src/app/app.config";
import {AppService} from "src/app/clearpath-module/services";
import {takeUntil} from "rxjs/operators";
import {Actions, ofType} from "@ngrx/effects";
import * as dealActions from "../../../clearpath-module/store/actions/deal.actions";
import swal, {SweetAlertOptions} from "sweetalert2";
import {Subject} from "rxjs";
import {CdkDragDrop, moveItemInArray, transferArrayItem} from "@angular/cdk/drag-drop";
import {CnaService} from "../../../clearpath-module/services/cna.service";
import {PubNubAngular} from "pubnub-angular2";
import {environment} from "../../../../environments/environment";
import {ToastrService} from "ngx-toastr";

@Component({
  selector: "app-navbar",
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.scss"]
})
export class NavbarComponent implements OnInit {
  @ViewChild('cnaModal') modalElement!: ElementRef;
  private unsubscribe$ = new Subject();
  @Input() currentUser: User;
  @Input() currentRelease: string;
  @Input() currentRoute: string;
  userRoles: string[];

  private uiState = {
    routes: {
      admin: [],
      standard: []
    }
  };

  constructor(
    public appService: AppService,
    private pubnub: PubNubAngular,
    private authService: AuthService,
    public cnaService: CnaService,
    private router: Router,
    private actions$: Actions,
    private toastr: ToastrService
  ) {
  }

  ngOnInit() {
    this.userRoles = User.unpackSecurityGroups(this.currentUser.securityGroups);
    this.initializeRoutes();
    this.actions$.pipe(
      takeUntil(this.unsubscribe$),
      ofType(dealActions.notificationsClicked),
    ).subscribe({
      next: () => {
        if (this.router.url !== "/sales-manager/list") {
          this.router.navigate(["/sales-manager/list"]);
        }
      }
    });

    this.pubnub.subscribe({
      channels: [environment.msgChannel],
      triggerEvents: true
    });
    const self = this;
    this.pubnub.getMessage(environment.msgChannel, function ({message}) {
      if (!(message.length == 2 && message[0].startsWith('{deal'))) {
        //console.log("Message Received Navbar:", message, self.currentUser);
        if (message.type == 'WriteupCreated' && (self.isSalesManager() || self.isSysAdmin()) && !self.currentUser.suppressPresentationStarted && message.userId != self.currentUser.employeeId) {
          console.log("user check", message.userId, self.currentUser.employeeId);

          self.toastr.info(
            "<small><b>"+message.salesPersonName+"</b><br>Customer: <b>"+message.customerName+"</b><br>Stock #: <b>"+message.stockNumber+"</b><br>- <a href='/sales-manager/writeup/"+message.dealId+"' style='text-decoration: underline!important'>View Deal in Desking</a><br>- <a href='/sales-manager/activity/"+message.dealId+"' style='text-decoration: underline!important'>View Activity Tracker</a></small>",
            "PRESENTATION STARTED",
            { timeOut: 20000 })

          /*swal.fire({
            title: "Presentation Started",
            html: `Sales Person: <b>${message.salesPersonName}</b><br>Customer: <b>${message.customerName}</b><br>Stock #: <b>${message.stockNumber}</b><br><br><a href="/sales-manager/activity/${message.dealId}">View Activity Tracker</a>`,
            icon: "success",
            showConfirmButton: true,
            confirmButtonText: "OK",
          } as SweetAlertOptions).then();*/
        }
      }
    });
  }

  initializeRoutes() {
    const {
      adminRoutes,
      standardOpenRoutes,
      standardRoleBasedRoutes
    } = this.routeRegistry;

    if (this.isSysAdmin()) {
      adminRoutes.forEach(route => {
        this.uiState.routes.admin.push(route);
      });
    }

    standardOpenRoutes.forEach(route => {
      this.uiState.routes.standard.push(route);
    });

    standardRoleBasedRoutes.forEach(route => {
      const authorizedUser = this.isSysAdmin() || this.userRoles.includes(route.role);
      if (authorizedUser) {
        if (this.isSysAdmin()) {
          this.addSysAdminRouteDescription(route);
        }
        this.uiState.routes.standard.push(route);
      }
    });
  }

  get routeRegistry() {
    return {
      adminRoutes: [
        {routerLink: "/user", title: "Users"},
        {routerLink: "/settings", title: "Settings"},
      ],
      standardOpenRoutes: [
        {routerLink: "/clearpath/credit-check", title: "Credit Check"},
        {routerLink: "/clearpath/new-deal", title: "Create Writeup"},
        {routerLink: "/clearpath/list", title: "Presentation"},
      ],
      standardRoleBasedRoutes: [
        // {routerLink: "/cna/list", title: "Customer Portrait", role: USER_ROLES.sales_floor},
        // {routerLink: "/inventory/list", title: "Inventory", role: USER_ROLES.sales_floor},
        {routerLink: "/sales-manager/list", title: "Desking", role: USER_ROLES.sales_manager},
        {routerLink: "/settings", title: "Administration", role: USER_ROLES.sys_admin},
        // {routerLink: "/sales-queue-admin", title: "Cue Admin", role: USER_ROLES.cue_admin},
        // {routerLink: "/sales-queue-view", title: "Cue View", role: USER_ROLES.sales_floor},
        // {routerLink: "/sales-queue-display", title: "Cue Display", role: USER_ROLES.cue_display},
      ],
    };
  }

  addSysAdminRouteDescription(route) {
    if (route.routerLink === "/inventory/list") {
      route.title = "Inventory";
    }
    if (route.routerLink === "/cna/list") {
      route.title = "CNA";
    }
    if (route.routerLink === "/sales-manager/list") {
      route.title = "Desking";
    }
    if (route.routerLink === "/clearpath/list") {
      route.title = "Presentation";
    }
  }

  logoClicked() {
    if (this.currentUser?.devMode) {
      this.appService.devSidenavOpened = !this.appService.devSidenavOpened;
    }
  }

  btLogoClicked(e) {
    /*if (e) e.preventDefault();
    this.saveDeal();
    window.location.href = 'https://www.beavertontoyota.com/';*/
  }

  get userName(): string {
    const {firstName, lastName} = this.currentUser;
    return `${firstName} ${lastName}`;
  }

  isSysAdmin(): boolean {
    return this.userRoles.includes(USER_ROLES.sys_admin);
  }

  isSalesManager(): boolean {
    return this.userRoles.includes(USER_ROLES.sales_manager);
  }

  logout() {
    this.authService.logout();
  }

  drop(event: CdkDragDrop<string[]>) {
    // console.log("Event:", event)
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      if (event.container.id === "targetList") {
        // console.log("Target list length:", event.container.data.length)
        if (event.container.data.length >= 4) {
          // console.log("Target list too long! Not adding Item");
          swal.fire({
            title: "Maximum Priorities Reached",
            html: "A maximum of 4 customer priorities is permitted at once.  Please remove a priority before adding a new one to the list.",
            icon: "warning",
            showConfirmButton: true,
            confirmButtonText: "OK",
          } as SweetAlertOptions).then();
          return;
        }
      }
      transferArrayItem(event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex);
    }
  }

  updateCustomerFirstName($event) {
    this.cnaService.firstName = $event;
  }

  updateCustomerLastName($event) {
    this.cnaService.lastName = $event;
  }

  resetForm() {
    this.cnaService.resetForm();
  }

  getOptionIcon(option: string): string {
    return "/static/images/cna_icons/" + (option.toLowerCase().replace(' ', '_')) + '.png';
  }

  modulePathLink(path: string) {
    console.log("modulePresentation");
    this.router.navigate([path]).then();
  }

  clearFocus(target) {
    // console.log("clearFocus:", target)
    if (target) {
      target.blur();
    }
  }

  toastTest() {
    this.toastr.info('<small>Sales Person: Gerald Griffin<br>Customer: John Doe<br>Stock #: 123456<br><br><a href="/sales-manager/activity/123456">View Activity Tracker</a></small>', 'Presentation Started', { timeOut: 20000 })
  }
}
